import { useEffect } from 'react';

export const useBootstrapModalBlur = (modalId: string) => {
    const blurActiveElement = () => {
        const activeElement = document.activeElement as HTMLElement;
        activeElement?.blur();
    };

    useEffect(() => {
        const modalElement = document.getElementById(modalId);
        modalElement?.addEventListener('hide.bs.modal', blurActiveElement);
        return () => {
            modalElement?.removeEventListener('hide.bs.modal', blurActiveElement);
        };
    }, []);
};
